import * as commonGetters from './common'

export default {
    ...commonGetters
}
